import { Component, ViewEncapsulation } from '@angular/core';
import { HttpModule } from '@angular/http';
import {Injectable, Inject} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import { RouterModule, Routes, Router } from '@angular/router';
import { ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { API_URL } from '../../globals';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import * as moment from 'moment';
import {IOption} from 'ng-select';

import * as $ from 'jquery';
import { ModalDirective } from 'ngx-bootstrap/modal';
import 'rxjs/add/observable/interval';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})


export class AppHeaderComponent {
	private data:any;
	private proilefiles:any;
	private checkVal:any;
	private api_url:any;
	private user:any = [];
	private profilePath: any;
  	private countries: any;
  	private userRoleName: any;
	private userLoggedInName:any = localStorage.getItem('currentUserName');
	private isAdminLoginAsStaff:any = localStorage.getItem('previousUserId') ? localStorage.getItem('previousUserId') : '';
	
	constructor(private NgxRolesService: NgxRolesService, private NgxPermissionsService: NgxPermissionsService, private router:Router, private http: Http) {

		this.userRoleName =  localStorage.getItem('currentUserRole');


    if(localStorage.getItem('previousUserRoleId') == localStorage.getItem('currentUserRoleId') && localStorage.getItem('previousUserRoleId') == '5af91f2e201e873904eb02ba') {
      localStorage.setItem('previousUserRoleId', '');
      localStorage.setItem('previousUserId', '');
    }

		if((localStorage.getItem('currentUserMainPermissions')).indexOf('dealerprofile') > -1){
			this.profilePath = '/profile/dealer';
		} else {
			this.profilePath = '/profile/staff'
		}


		this.NgxRolesService.flushRoles();

	    if(localStorage.getItem('currentUserRole') != null) { 
	   	this.NgxRolesService.addRole(localStorage.getItem('currentUserRole'), ['A'] );
	   } else {
	   	this.NgxRolesService.addRole("GUEST", ['A'] );	   
	   }

	    let roles = NgxRolesService.getRoles();
	    NgxRolesService.roles$.subscribe((data) => {
	       
	    })

	    let options = new RequestOptions();
        options.headers = new Headers();
        options.headers.append('Content-Type', 'application/json');
        options.headers.append('Accept', 'application/json');		
  

	     let interval = setInterval(() => {  
			let userToken = localStorage.getItem('currentUserToken');
			let urlArr = window.location.href.split("/");
			if(userToken == null && urlArr[(urlArr.length) - 1] != 'login'){
				localStorage.clear();
				this.logout();
				window.location.href = "/#/login/";
			}
	    }, 1000);

		let newInterval = setInterval(() => {  
	     	if(localStorage.getItem('currentUserId') != null) {
		     	/*
				this.http.get(API_URL+'/Members?filter={"where":{"and":[{"and":[{"active":{"neq":0}}, {"status":{"neq":"0"}}]},{"id":"'+ localStorage.getItem('currentUserId') +'"}]}}&access_token='+localStorage.getItem('currentUserToken'), options)  
				.subscribe(response => {
					if(response.json() == '') {
		            	localStorage.clear();
						this.logout();
						window.location.href = "/#/login/";
					}	
		        }, error => {
		            console.log(JSON.stringify(error.json()));
		        });  
				*/
		       this.http.post(API_URL+'/Members/accessTokenCheck?access_token='+ localStorage.getItem('currentUserToken'), {
		          "id": localStorage.getItem('currentUserId')} , options)
		        .subscribe(response => {
		          if(response.json().data == null ){
		            //this.logout();
		            localStorage.clear();
		            window.location.href = "/#/login/";
		          }          
		        }, error => {
					localStorage.clear();
		        });
	       }
	    }, 300000);


		
        this.http.get(API_URL+'/Countries/?filter={"where":{"active":{"neq":0}}}&access_token='+ localStorage.getItem('currentUserToken'), options)
        .subscribe(response => {        	
        	this.countries = response.json();
	    }, error => {
	        console.log(JSON.stringify(error.json()));
	    });
		
		this.api_url = API_URL;
		
		if((localStorage.getItem('currentUserMainPermissions')).indexOf('dealerprofile') > -1){
			 this.http.get(API_URL+'/addresses/?filter={"where":{"memberId":"'+localStorage.getItem('currentUserId')+'"}}&access_token='+ localStorage.getItem('currentUserToken'), options)
	      	.subscribe(userRes => {
	      		// console.log(userRes.json()[0].loccountry);
			 	this.user.country = userRes.json()[0].loccountry;

			 	if(localStorage.getItem('currentUserCountry') == null ) {
			 		localStorage.setItem('currentUserCountry',this.user.country);
			 	} else {
					this.user.country = localStorage.getItem('currentUserCountry');
			 	}
			 	this.user.areas = "no";
	      	}, error => {
	        	console.log(JSON.stringify(error.json()));
	      	});
		} else {
		this.http.get(API_URL+'/Members/'+localStorage.getItem('currentUserId')+'?access_token='+ localStorage.getItem('currentUserToken'), options)
	      	.subscribe(userRes => {
			 	this.user.country = userRes.json().country;
			 	if(localStorage.getItem('currentUserCountry') == null) {
			 		localStorage.setItem('currentUserCountry',this.user.country);
			 	} else {
					this.user.country = localStorage.getItem('currentUserCountry');
			 	}
			 	this.user.areas = userRes.json().other_area;
	      	}, error => {
	        	console.log(JSON.stringify(error.json()));
	      	});
		}




	
		
		this.data = {};
		
		this.http.get(API_URL+'/FileStorages?filter={"where":{"filePath":"/Containers/'+localStorage.getItem('currentUserId')+'","uploadType":"profile","status":"active"}}&access_token='+ localStorage.getItem('currentUserToken'), options)
        .subscribe(response => {        	
			if(response.json().length == 0){
				this.checkVal = 0;
			} else {
				this.checkVal = 1;
				this.proilefiles = response.json()[0];
			}
        }, error => {
            console.log(JSON.stringify(error.json()));
        });		
		
  	}

	onDesignatedArea(){  	
		localStorage.setItem('currentUserCountry',this.user.country);
		this.user.country = localStorage.getItem('currentUserCountry');
		window.location.reload(true);
	}


  loginBackAsAdmin() {
    let options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');
    options.headers.append('Accept', 'application/json');

    this.http.get(API_URL+'/Members/'+localStorage.getItem('previousUserId')+'/accessTokens?access_token='+ localStorage.getItem('currentUserToken'), options)
      .subscribe(response => {
        console.log(response.json());  

        this.http.get(API_URL+'/Members/'+ localStorage.getItem('previousUserId')+'?access_token='+ localStorage.getItem('currentUserToken'), options)
        .subscribe(res => {
          localStorage.setItem('currentUserRoleId', res.json().role_id);
          localStorage.setItem('currentUser', res.json());
          localStorage.setItem('currentUserId', res.json().id);
          localStorage.setItem('currentUserName', res.json().name);

          this.http.get(API_URL+'/Roles?filter={"where":{"id":"'+res.json().role_id+'"}}&access_token='+ localStorage.getItem('currentUserToken'), options)
          .subscribe(res => {
            localStorage.setItem('currentUserMainPermissions', res.json()[0].permission);
            localStorage.setItem('currentUserInnerPermissions', res.json()[0].permissionInside);
            localStorage.setItem('currentUserRole', res.json()[0].name);
          }, error => {

          });

          localStorage.setItem('currentUserToken', response.json()[0].id);
          localStorage.setItem('rowsOnPage', "10");
          localStorage.setItem('activePage', "1");
          
          this.router.navigate(['dashboard']);
        }, error => {

        }); 
    }, error => {
        console.log(JSON.stringify(error.json()));
    });
  }

	logout() {
	    let options = new RequestOptions();
	    options.headers = new Headers();
	    options.headers.append('Content-Type', 'application/json');
	    options.headers.append('Accept', 'application/json');
		
	    this.http.post(API_URL+'/Members/logout?access_token='+ localStorage.getItem('currentUserToken'), this.data ,  options)
	    .subscribe(response => {
	      		console.log(response.json());
	    	}, error => {
	          console.log(error.json());
	  		}
	  	);
		localStorage.clear();
	    this.NgxRolesService.flushRoles();
	    this.router.navigate(['login']);
		// Navigate to the login page
		this.router.navigate(['/login'])
		.then(() => {
		  // Refresh the page
		  window.location.reload();
		});
	}

 }



// WEBPACK FOOTER //
// /var/www/portal/bullseye/src/app/components/app-header/app-header.component.ts